import * as React from 'react';
import style from './RelatedContentEndOfArticle.scss';
import { Rectangle } from '../../PageElements/Rectangle/Rectangle';
import { Text } from '../../PageElements/Text';
import { ReactMarkdownDisplay } from '../../PageElements/ReactMarkdownDisplay';

export const RelatedContentEndOfArticle = ({ links, prefix }) => {
  const linksMarkdown = links.join(', ');
  return (
    <Rectangle className={style.container}>
      <Text weight="bold">Related Content:</Text>
      <ReactMarkdownDisplay
        markdown={linksMarkdown}
        textSize="small"
        textWeight="normal"
        prefix={prefix}
      />
    </Rectangle>
  );
};
